export class DocTypeIdentity {
  public id: number;
  public name: string;

  constructor(record?: DocTypeIdentity) {
    this.id = record && record.id || 5;
    this.name = record && record.name || '';
  }
}
